module.exports = __webpack_public_path__ + "img/terry_atl.93459e8a.jpg";